import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ColorModel } from 'src/app/edit/models/color.model';
import { ColorUtils } from '../../libraries/colors/colors';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorPickerComponent implements OnInit {
  @Input()
  color: ColorModel;

  @Input()
  size: 'small' | 'normal' | 'large' = 'normal';

  @Input()
  alphaEnabled: true;

  get colorHex(): string {
    return this.getHexFromColor(this.color);
  }

  get backgroundCSS(): string {
    if (this.color) {
      const { red, green, blue, alpha } = this.color;
      return `rgba(${red * 255}, ${green * 255}, ${blue * 255}, ${alpha})`;
    } else {
      return '';
    }
  }

  @Output()
  colorSelected = new EventEmitter<ColorModel>();

  @Output()
  colorHexSelected = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  handleColorPickerChange(hexColor: string) {
    const selectedColor = hexColor ? this.getColorFromHex(hexColor) : null;

    // dispatch color selection
    this.colorSelected.emit(selectedColor);
    this.colorHexSelected.emit(hexColor);
  }

  private getColorFromHex(hexColor: string): ColorModel {
    const rgba = ColorUtils.hexToRgba(hexColor, true);
    return new ColorModel(rgba[0], rgba[1], rgba[2], rgba[3]);
  }

  private getHexFromColor(color: ColorModel): string {
    if (color) {
      const { red, green, blue, alpha } = color;
      return ColorUtils.rgbaToHex([red, green, blue, alpha], true);
    } else {
      return '';
    }
  }
}
